/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import accounts from './accounts';
import analytics from './analytics';
import dashboard from './dashboard';
import inventory from './inventory';
import profiles from './profiles';
import rolesPermissions from './roles-permissions';
import sales from './sales';
import setup from './setup';
import digitalInvoicing from './digital-invoicing';
import fbrInvoice from './fbr-invoice';
// import appsAndPages from './apps-and-pages'
// import appsAndPagesAll from './appsAndPagesAll'

//import others from './others'
//import chartsAndMaps from './charts-and-maps'
//import uiElements from './ui-elements'
//import formAndTable from './forms-and-table'

// Array of sections
//export default [...dashboard, ...appsAndPages, ...uiElements, ...formAndTable, ...chartsAndMaps, ...others]

// var pgToPass = appsAndPages;

// if($store.state.userData.roles === "admin")
// {
//   alert("admin");
//   pgToPass = appsAndPagesAll.myarr;
// }

export default [
  ...dashboard,
  ...profiles,
  ...inventory,
  ...sales,
  ...setup,
  ...digitalInvoicing,
  ...fbrInvoice,
  ...analytics,
  ...rolesPermissions,
  ...accounts,
];
